import {request} from "./request";


export function StuLogin(stuname, stunum, platform = "web") {
  return request({
    url: 'student/login',
    params: {
      stuname,
      stunum,
      platform
    }
  })
}

export function TeaLogin(tecnum, pwd, platform = "web") {
  return request({
    url: 'teacher/login',
    params: {
      tecnum, pwd, platform
    }
  })
}

export function AdmLogin(username, pwd) {
  return request({
    url: 'admin/login',
    params: {
      username,
      pwd
    }
  })
}

